import * as _ from "lodash";
import {ILogService} from "angular";
import {StudyUnitService} from "./study-unit.service";
import "./study-unit-selector.less";
import {Credit} from "../model/Credit";
import {CreditRecord} from "../model/CreditRecord";
import {Application} from "../model/Application";

export interface StudyUnit {
    id: string;
    unitCode: string;
    version: string;
    active: boolean;
    category: string;
    title: string;
    shortTitle: string;
    level: string;
    research: boolean;
    achievableCreditPoints: number;
    enrolledCreditPoints: number;

}

class StudyUnitSelectorController {

    private credit: Credit;
    private unitActive: boolean;
    private id: string;
    private loading: boolean;
    private noResults: boolean;
    private application: Application;
    private courseCodes: string[];
    private grantedAlreadyExistedInCallista:boolean;
    private activeOnly: boolean;
    private queryUnitCode: string;

    /* @ngInject */
    constructor(private $log: ILogService,
                private toaster: any,
                private studyUnitService: StudyUnitService) {
    }

    public $onInit() {
        this.id = "study-unit-" + _.random(0, 9999);
        this.activeOnly = true;
        this.noResults = false;
        this.queryUnitCode = this.credit.monashUnitCode;
    }

    public searchStudyUnits(query) {
        this.$log.debug("searchStudyUnits: %o", query);
        // not allow the same unit to be assessed when it is already existed in Callista as approved or granted.
        this.grantedAlreadyExistedInCallista = false
        this.courseCodes.forEach(code => {
                this.$log.info(code)
                this.$log.info(this.application.applicant.creditRecords)
                if (this.application.applicant.creditRecords && this.application.applicant.creditRecords
                    .filter((credit) => code.split('-', 1)[0] == credit.courseCode)
                    .filter((credit) => credit.creditType == 'specifiedCredit')
                    .filter(c => c.grantingStatus === 'GRANTED' || c.grantingStatus === 'APPROVED')
                    .filter(c => c.unitCode.toLowerCase() == query.toLowerCase()).length > 0) {
                    this.$log.info('existed found')
                    this.grantedAlreadyExistedInCallista = true;
                    return;
                }

            }
        )

        if (this.grantedAlreadyExistedInCallista) {
            return -1;
        }

        return this.studyUnitService.search(query, this.activeOnly)
            .then((results) => {
                this.noResults = results.length <= 0;
                return results;
            })
            .then((results) => results.sort((a, b) => {
            if (a.active === b.active) {
                // Secondary sort by version.
                return Number(b.version) - Number(a.version);
            } else if (a.active) {
                return -1;
            } else {
                // b.active is true
                return 1;
            }
        }));
    }

    public onSelectStudyUnit($item: StudyUnit, $model, $label, $event) {
        this.$log.debug("selected $item: %o, $model: %o, $label: %o, $event: %o", $item, $model, $label, $event);
        this.credit.monashUnitCode = $item.unitCode;
        this.credit.monashUnitVersion = $item.version;
        this.credit.creditPoints = $item.achievableCreditPoints;
        this.unitActive = $item.active;
    }

}

export const StudyUnitSelectorComponent: angular.IComponentOptions = {
    bindings: {
        fieldLabel: "<",
        credit: "=",
        ngDisabled: "<",
        showErrors: "<",
        requiredFlag: "<",
        unitCodeOnly: "<",
        specifiedCreditType: "<",
        hideCredit: "<",
        application: "=",
        courseCodes: "="
    },
    controller: StudyUnitSelectorController,
    template: require("./study-unit-selector.html")
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/study-unit/study-unit-selector.component.ts